export default __webpack_public_path__ + "static/media/planit_logo_dark.e043cb18.svg";